import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './en.bundle';
import { it } from './it.bundle';

const fr = {
  translation: {
    common: {
      loading: 'Chargement...',
      error: 'Une erreur est survenue',
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      add: 'Ajouter',
      confirm: 'Confirmer',
      back: 'Retour',
      search: 'Rechercher...',
      noResults: 'Aucun résultat',
      currency: 'CHF',
    },
    nav: {
      dashboard: 'Tableau de bord',
      orders: 'Commandes',
      products: 'Catalogue',
      stats: 'Statistiques',
      settings: 'Paramètres',
      support: 'Assistance',
      logout: 'Déconnexion',
      login: 'Connexion',
      openMenu: 'Ouvrir le menu',
      closeMenu: 'Fermer le menu',
      mainNav: 'Navigation principale',
    },
    session: {
      timeoutTitle: 'Déconnexion automatique',
      timeoutLabel: 'Délai d\'inactivité',
      timeoutHint: 'Après une période sans activité, vous serez déconnecté automatiquement.',
      timeoutSaved: 'Délai enregistré.',
      timeout15: '15 minutes',
      timeout30: '30 minutes',
      timeout60: '1 heure',
      timeout120: '2 heures',
      timeout240: '4 heures',
      timeoutNever: 'Jamais (non recommandé)',
      inactivityLogout: 'Session expirée pour inactivité. Veuillez vous reconnecter.',
    },
    auth: {
      login: 'Se connecter',
      register: 'Créer un compte',
      email: 'Email',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      noAccount: 'Pas encore de compte ?',
      hasAccount: 'Déjà un compte ?',
      demoAccountsTitle: 'Comptes de démonstration :',
      demoAccountsHint: 'Cliquez sur une ligne pour préremplir l’e-mail et le mot de passe.',
      demoRoleAdmin: 'Administrateur',
      demoRoleMerchant: 'Commerçant',
      demoRoleDriver: 'Livreur',
      demoRoleCustomer: 'Cliente',
    },
    dashboard: {
      welcome: 'Bonjour, {{name}} !',
      todayOrders: 'Commandes aujourd\'hui',
      todayRevenue: 'CA aujourd\'hui',
      avgBasket: 'Panier moyen',
      avgRating: 'Note moyenne',
      newOrders: 'Nouvelles commandes',
      inProgress: 'En cours',
      shopStatus: 'Statut boutique',
      open: 'Ouvert',
      closed: 'Fermé',
      closeNow: 'Fermer maintenant',
      topProducts: 'Top produits aujourd\'hui',
      storefrontPendingTitle: 'Vitrine en attente de validation',
      storefrontPending: 'Votre vitrine n’est pas encore en ligne. Les clients ne la voient pas tant que BienLivrer ne l’a pas validée.',
      plans: {
        link: 'Voir les formules',
        title: 'Vos formules',
        intro: 'Démarrage est gratuit. Pro et Premium baissent la commission et élèvent le plafond du catalogue. Une formule payante démarre le 1er du mois suivant, à 00:00 (heure suisse), et se renouvelle chaque mois.',
        free: 'Gratuit',
        perMonth: '{{price}} CHF / mois',
        commission: 'Commission {{rate}} %',
        products: '{{max}} produits au catalogue',
        current: 'Formule actuelle',
        choose: 'Choisir {{name}}',
        backToStarter: 'Revenir à Démarrage',
        keep: 'Conserver {{name}}',
        scheduled: 'Retour prévu',
        cancelScheduled: 'Retour à Démarrage le {{date}} à 00:00 (heure suisse). Jusqu’à cette date, la formule payante reste active.',
        portal: 'Factures et moyen de paiement',
        checkoutUnavailable: 'La souscription en ligne n’est pas encore ouverte. Écrivez à BienLivrer pour changer de formule.',
        demoReadonly: 'Le compte de démonstration ne peut pas souscrire.',
        success: 'Carte enregistrée. L’abonnement récurrent sera actif le 1er du mois suivant à 00:00 (heure suisse).',
        cancelledCheckout: 'Souscription interrompue. Aucun prélèvement n’a été fait.',
        catalogOver: 'Votre catalogue compte {{count}} produits, au-dessus du plafond de cette formule ({{max}}). Les produits déjà en ligne restent ; vous ne pourrez plus en ajouter tant que le surplus n’est pas archivé.',
        trialDefer: 'Le premier prélèvement a lieu après la fin de votre essai.',
        trialSoon: 'Votre essai se termine dans moins de 48 heures : le prélèvement mensuel commence dès la souscription.',
        error: 'Impossible de changer de formule pour le moment.',
        confirmTitle: 'Activer un abonnement récurrent',
        confirmBody: 'Vous allez activer l’abonnement {{name}} à {{price}} CHF par mois. Il sera actif à partir du {{date}} à 00:00 (heure suisse). Il se renouvelle ensuite chaque mois, jusqu’à ce que vous reveniez à Démarrage.',
        confirmYes: 'Activer l’abonnement',
        confirmNo: 'Annuler',
        confirmCancelTitle: 'Annuler l’abonnement récurrent',
        confirmCancelBody: 'Vous allez annuler l’abonnement récurrent {{name}}. Il reste actif jusqu’au {{date}} à 00:00 (heure suisse). À partir de cette date, vous revenez à Démarrage et le prélèvement mensuel s’arrête.',
        confirmCancelPending: 'Vous allez annuler l’abonnement récurrent {{name}}. Il ne sera pas activé. L’annulation prend effet le {{date}} à 00:00 (heure suisse).',
        confirmCancelYes: 'Annuler l’abonnement',
        confirmCancelNo: 'Retour',
        pendingStart: '{{name}} sera actif le {{date}} à 00:00 (heure suisse). Le prélèvement se répète chaque mois.',
        planned: 'Déjà prévu',
        names: {
          starter: 'Démarrage',
          pro: 'Pro',
          premium: 'Premium',
        },
      },
    },
    orders: {
      title: 'Commandes',
      number: 'N° commande',
      customer: 'Client',
      status: 'Statut',
      total: 'Total',
      type: 'Type',
      date: 'Date',
      accept: 'Accepter',
      refuse: 'Refuser',
      markReady: 'Marquer prête',
      prepare: 'Préparer',
      confirmPickup: 'Marquer retirée',
      delivery: 'Livraison',
      click_collect: 'Retrait',
      statuses: {
        pending: 'En attente',
        accepted: 'Acceptée',
        preparing: 'Préparation',
        ready: 'Prête',
        pickup: 'Livreur en route',
        delivering: 'En livraison',
        delivered: 'Livrée',
        completed: 'Retirée',
        cancelled: 'Annulée',
        refunded: 'Remboursée',
        pending_payment: 'Paiement en attente',
      },
    },
    products: {
      title: 'Mon catalogue',
      add: 'Nouveau produit',
      name: 'Nom du produit',
      nameFr: 'Nom (Français)',
      nameDe: 'Name (Deutsch)',
      nameEn: 'Name (English)',
      price: 'Prix CHF',
      stock: 'Stock',
      unlimited: 'Illimité',
      status: 'Statut',
      category: 'Catégorie',
      active: 'Actif',
      draft: 'Brouillon',
      out_of_stock: 'Épuisé',
      allergens: 'Allergènes',
      vatRate: 'Taux TVA',
    },
    onboarding: {
      title: 'Créer votre commerce',
      step1: 'Informations de base',
      step2: 'Horaires',
      step3: 'Informations bancaires',
      step4: 'Premier produit',
      next: 'Suivant',
      previous: 'Précédent',
      finish: 'Terminer',
    },
    client: {
      home: 'Accueil',
      myOrders: 'Mes commandes',
      myProfile: 'Mon profil',
      cart: 'Panier',
      addToCart: 'Ajouter au panier',
      addedToCartToast: 'Ajouté au panier',
      viewCart: 'Voir le panier',
      addedToCartLive: '{{name}} ajouté au panier.',
      removeFromCart: 'Retirer du panier',
      emptyCart: 'Votre panier est vide',
      orderNow: 'Commander',
      deliveryAddress: 'Adresse de livraison',
      deliveryOrPickup: 'Livraison ou retrait ?',
      notes: 'Instructions spéciales (facultatif)',
      coupon: 'Code promo',
      applyCoupon: 'Appliquer',
      subtotal: 'Sous-total',
      deliveryFee: 'Frais de livraison',
      serviceFee: 'Frais de service',
      packagingDeposit: 'Caution emballage',
      discount: 'Réduction',
      total: 'Total',
      placeOrder: 'Passer la commande',
      orderPlaced: 'Commande passée !',
      trackOrder: 'Suivre ma commande',
      pickupCode: 'Code de retrait',
      estimatedTime: 'Temps estimé',
      deliveryIn: 'Livraison dans ~{{min}} min',
      pickupIn: 'Prêt dans ~{{min}} min',
      activeOrders: 'En cours',
      orderHistory: 'Historique',
      noActiveOrders: 'Aucune commande en cours',
      noHistory: 'Aucune commande passée',
      checkout: {
        errorGeneric: 'Impossible de finaliser la commande. Réessayez.',
        errorNetwork: 'Pas de connexion ou serveur injoignable.',
        errorServer: 'Erreur serveur. Réessayez dans quelques instants.',
        errorValidation: 'Données invalides. Vérifiez le formulaire.',
        errorUnauthorized: 'Connectez-vous pour passer commande.',
        submitting: 'Commande en cours…',
        payCard: 'Paiement en ligne',
        payQrBill: 'QR-facture',
        payCash: 'Espèces au retrait',
        payCashHint:
          'Vous réglerez le montant total (produits et frais de service) en espèces au comptoir lors du retrait.',
        payCashDeliveryOnly: 'Réservé au retrait en magasin',
        payCashLocked:
          'Disponible à partir de votre {{fromOrder}}e commande payée en ligne ({{current}}/{{required}} terminées).',
        payCashUnavailableDeposit:
          'Le paiement en espèces n’est pas disponible : une caution d’emballage doit être encaissée en ligne pour pouvoir vous la rendre.',
        payCashCta: 'Commander et payer au retrait — CHF {{total}}',
        cartDialogTitle: 'Panier',
        cartOpened: 'Panier ouvert. {{count}} article(s). Montant total {{total}} CHF.',
        cartClosed: 'Panier fermé.',
        loginToOrderTitle: 'Connexion requise',
        loginToOrderHint:
          'Connectez-vous, créez un compte ou utilisez le formulaire invité ci-dessous. Votre panier et vos choix (retrait / livraison, paiement) seront conservés.',
        loginToOrderCta: 'Se connecter pour commander',
        loginToOrderRegister: 'Créer un compte',
        guestCheckoutToggle: 'Commander sans compte',
        guestCheckoutHint:
          'Aucun compte n’est créé. Nous utilisons ces informations uniquement pour traiter votre commande et vous contacter (confirmation, livraison).',
        guestFirstNameLabel: 'Prénom',
        guestLastNameLabel: 'Nom',
        guestEmailLabel: 'E-mail',
        guestPhoneOptionalLabel: 'Téléphone (optionnel, +41…)',
        guestPhoneInvalid: 'Téléphone invalide : utilisez +41 suivi de 9 chiffres.',
        guestSubmitCta: 'Commander en tant qu’invité',
        guestSubmitting: 'Envoi en cours…',
        guestDividerOr: 'ou',
        continueToPayment: 'Continuer vers le paiement',
        preparePaymentCta: 'Continuer vers le paiement — CHF {{total}}',
        orderWithPaymentObligation: 'Commander avec obligation de paiement — CHF {{total}}',
        acceptLegalRequired: 'Veuillez accepter les CGV et les CGU pour continuer.',
        paymentNotConfirmedYet:
          'La commande ne sera confirmée qu’après validation du paiement (carte ou TWINT).',
        backToSummary: 'Retour au panier',
        stripePayTitle: 'Paiement sécurisé',
        stripePaySubtitle: 'Carte bancaire — commande en attente jusqu’à validation du paiement.',
        stripePayCta: 'Payer CHF {{total}} — obligation de paiement',
        stripePayProcessing: 'Traitement…',
        awaitingPaymentTitle: 'Commande enregistrée',
        awaitingPaymentBody:
          'Un e-mail vous indique la suite (carte ou TWINT). Vous pouvez suivre la commande dans « Mes commandes ».',
        awaitingPaymentBodyGuest:
          'Un e-mail vous indique la suite (carte ou TWINT). Conservez votre numéro de commande ci-dessous.',
        stripePollTimeout:
          'Le paiement peut encore être confirmé. Ouvrez « Mes commandes » dans quelques instants.',
        stripeOrderCancelled: 'La commande a été annulée (paiement non abouti).',
        wrongRoleHint:
          'Vous êtes connecté avec un compte commerçant ou livreur. Déconnectez-vous puis connectez-vous avec un compte client pour commander ici.',
        sectionAccount: 'Compte',
        sectionFulfillment: 'Retrait ou livraison',
        sectionYourOrder: 'Votre commande',
        sectionSummary: 'Récapitulatif',
        sectionPayment: 'Mode de paiement',
        signedInAs: 'Connecté en tant que',
        tabHasAccount: 'J’ai déjà un compte',
        tabGuest: 'Commander sans compte',
        deliveryAddressShort: 'Adresse de livraison',
        totalTvaHint: 'TVA incluse le cas échéant',
        paymentChooseHint: 'Choisissez comment vous souhaitez payer.',
        paymentOnlineHint:
          'Paiement sécurisé en ligne par carte bancaire ou TWINT (via Stripe). Aucun espèces ni QR-facture.',
        serviceFeeHint: 'Inclut le traitement du paiement sécurisé.',
      },
      ordersConnection: {
        offline: 'Hors ligne — le suivi se mettra à jour à la reconnexion.',
        online: 'Connexion rétablie.',
        syncing: 'Actualisation des commandes…',
      },
      profile: {
        title: 'Mon profil',
        firstNameLabel: 'Prénom',
        lastNameLabel: 'Nom',
        emailLabel: 'Adresse e-mail',
        phoneLabel: 'Téléphone',
        firstNameRequired: 'Prénom requis',
        lastNameRequired: 'Nom requis',
        emailInvalid: 'E-mail invalide',
        saveBtn: 'Enregistrer',
        saved: 'Profil enregistré.',
        saveFailed: "Échec de l'enregistrement. Veuillez réessayer.",
        gdprTitle: 'Données personnelles (RGPD)',
        gdprExport: 'Exporter mes données',
        gdprDelete: 'Supprimer mon compte',
        gdprDeleteConfirm: 'Votre compte sera anonymisé. Cette action est irréversible. Continuer ?',
        gdprPasswordLabel: 'Mot de passe pour confirmer la suppression',
        gdprPasswordRequired: 'Saisissez votre mot de passe pour supprimer le compte.',
        gdprRequestSent: 'Votre demande a bien été envoyée.',
        changePasswordTitle: 'Changer le mot de passe',
        currentPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe (min. 8 caractères)',
        confirmPassword: 'Confirmer le nouveau mot de passe',
        passwordMismatch: 'Les mots de passe ne correspondent pas',
        passwordChanged: 'Mot de passe modifié avec succès.',
      },
      shop: {
        deliveryBadge: 'Livraison',
        clickCollectBadge: 'Click & Collect',
        pickup: 'Retrait en magasin',
        deliveryWithFee: 'Livraison (+CHF {{fee}})',
        deliveryFromFee: 'Livraison (CHF {{fee}})',
        deliveryOutOfZone: 'Hors zone de livraison',
        deliveryOffered: 'Offerte',
        deliveryOfferedLabel: 'Livraison offerte',
        categoryAll: 'Tout',
        products: 'Produits',
        noProducts: 'Aucun produit disponible',
        notFound: 'Commerce introuvable',
        orderPlacedTitle: 'Commande passée !',
        orderPlacedBody: 'Votre paiement est confirmé. Votre commande est en cours de traitement.',
        orderNumberLabel: 'N° commande',
        pickupCodeLabel: 'Code de retrait',
        newOrder: 'Nouvelle commande',
        viewCartShort: 'Voir le panier',
        cartArticleLabel: 'articles',
        closeCartOverlay: 'Fermer le panier',
        closeDialog: 'Fermer',
        deliveryAddressLabel: 'Adresse de livraison *',
        deliveryAddressPlaceholder: 'Rue Centrale 5, 2500 Ville',
        orderNoteLabel: 'Note (facultatif)',
        orderNotePlaceholder: 'Allergies, sans gluten...',
        paymentMethod: 'Mode de paiement',
        onlineOrderPrice: 'Prix commande en ligne',
        onlineOrderPriceHint: 'Les prix affichés sont ceux de la commande en ligne.',
        packagingDeposit: 'Caution emballage +CHF {{amount}}',
        packagingDepositHint:
          'Caution pour l’emballage spécial (froid, viande…). BienLivrer la garde et vous la reverse quand vous rendez l’emballage au magasin.',
      },
      homePage: {
        searchPlaceholder: 'Chercher un commerce...',
        closed: 'Fermé',
        open: 'Ouvert',
        demo: 'Démo',
        delivery: 'Livraison',
        pickup: 'Retrait',
        minOrder: 'Min. CHF {{amount}}',
        driverArea: 'Espace livreur',
        driverProfile: 'Profil livreur',
        merchantDashboard: 'Tableau de bord commerçant',
        merchantSettings: 'Paramètres boutique',
        admin: 'Administration',
        myOrders: 'Mes commandes',
        myProfile: 'Mon profil',
        logout: 'Se déconnecter',
        login: 'Connexion',
        announcementCta: 'Contact / détails',
        brandSlogan: 'Petit commerce, grande livraison.',
        heroTitle: 'Les commerces locaux, livrés chez vous',
        heroVision: 'La livraison locale, partout en Suisse',
        heroSubtitle: 'Commandez auprès des commerçants locaux — livraison en tournée du soir ou retrait en magasin',
        register: 'Créer un compte',
        loginCta: 'Se connecter',
        hello: 'Bonjour, {{name}} !',
        taglineDriver: 'Parcourez la vitrine ou gérez vos livraisons',
        taglineMerchant: 'Vitrine ou espace commerçant',
        taglineAdmin: 'Vitrine ou espace admin',
        taglineCustomer: "Que souhaitez-vous commander aujourd'hui ?",
        deliveriesLink: 'Livraisons',
        dashboardLink: 'Mon commerce',
        ordersLink: 'Mes commandes',
        featured: 'À la une',
        pinned: 'À ne pas manquer',
        pinnedBadge: 'Sélection',
        newPartners: 'Nouveaux partenaires',
        locationBanner: 'Commerces locaux disponibles près de chez vous',
        noResults: 'Aucun résultat',
        noShops: 'Aucun commerce disponible',
        resetSearch: 'Réinitialiser la recherche',
        shopCountOne: '{{count}} commerce',
        shopCountMany: '{{count}} commerces',
      },
    },
    driver: {
      title: 'Mes livraisons',
      space: 'Espace Livreur',
      available: 'Disponible',
      unavailable: 'Indisponible',
      activeDelivery: 'Livraison en cours',
      availableDeliveries: 'Courses disponibles',
      earnings: 'Gains de la semaine',
      accept: 'Accepter la course',
      refuse: 'Refuser',
      pickup: 'Aller chercher',
      deliver: 'Livrer',
      delivered: 'Livraison confirmée',
      distance: 'Distance',
      estimatedFee: 'Rémunération estimée',
      noDeliveries: 'Aucune course disponible',
      status: {
        searching: 'Recherche livreur',
        awaiting_manual: 'En attente assignation',
        pending_acceptance: 'À confirmer',
        assigned: 'Assignée',
        heading_to_shop: 'En route vers le commerce',
        at_shop: 'Au commerce',
        picked_up: 'Commande récupérée',
        delivering: 'En livraison',
        delivered: 'Livrée',
      },
    },
    admin: {
      title: 'Administration',
      console: 'Console de gestion BienLivrer',
      myProfile: 'Mon profil',
      overview: 'Vue d\'ensemble',
      shops: 'Commerces',
      users: 'Utilisateurs',
      orders: 'Commandes',
      coupons: 'Coupons',
      reviews: 'Avis',
      activeShops: 'Commerces actifs',
      totalUsers: 'Utilisateurs',
      totalOrders: 'Commandes totales',
      revenue: 'CA total (CHF)',
      verify: 'Vérifier',
      verified: 'Vérifié',
      active: 'Actif',
      inactive: 'Inactif',
      suspended: 'Suspendu',
      owner: 'Propriétaire',
      createdAt: 'Créé le',
      refresh: 'Actualiser',
      sessionTimeoutTitle: 'Déconnexion automatique',
      sessionTimeoutHint: 'Après une période sans activité sur la console admin, vous serez déconnecté automatiquement.',
      sessionTimeoutSaved: 'Délai enregistré.',
      sessionTimeout15: '15 minutes',
      sessionTimeout30: '30 minutes',
      sessionTimeout60: '1 heure',
      sessionTimeout120: '2 heures',
      sessionTimeout240: '4 heures',
      sessionTimeoutNever: 'Jamais (non recommandé)',
      sessionInactivityLogout: 'Session expirée pour inactivité. Veuillez vous reconnecter.',
    },
    gdpr: {
      cookieBanner: 'Nous utilisons des cookies pour améliorer votre expérience.',
      closeBanner: 'Fermer la bannière cookies',
      accept: 'Accepter',
      decline: 'Refuser',
      learnMore: 'En savoir plus',
      privacyPolicy: 'Politique de confidentialité',
      termsOfService: 'CGU',
    },
    errors: {
      notFound: 'Page introuvable',
      unauthorized: 'Accès non autorisé',
      serverError: 'Erreur serveur',
      networkError: 'Erreur réseau — vérifiez votre connexion',
      sessionExpired: 'Session expirée — veuillez vous reconnecter',
      shopClosed: 'Ce commerce est actuellement fermé',
      outOfStock: 'Produit épuisé',
      minOrder: 'Montant minimum non atteint (CHF {{amount}})',
    },
    merchantDemo: {
      bannerTitle: 'Environnement de démonstration',
      bannerBody: 'Boutique exemple « {{category}} ». Acceptez, préparez, imprimez et suivez jusqu’à la livraison — rien n’est enregistré.',
      changeCategory: 'Changer de type de boutique',
      pickerTitle: 'Choisissez votre type de commerce',
      pickerSubtitle: 'L’espace commerçant s’adapte à votre sélection (catalogue, commandes, statistiques…).',
      readOnlyHint: 'Parcours interactif — pour ouvrir votre vraie boutique, inscrivez-vous via « Devenir partenaire ».',
      persistBlocked: 'Environnement démo — aucune modification enregistrée.',
    },
    driverDemo: {
      bannerTitle: 'Environnement de démonstration livreur',
      bannerBody: 'Missions, carte et gains d’exemple. Acceptez et mettez à jour les statuts — rien n’est enregistré.',
      persistBlocked: 'Environnement démo — aucune modification enregistrée.',
    },
    devTestAccounts: {
      title: 'Comptes de test',
      subtitle: 'Environnement local uniquement. Assurez-vous d’avoir exécuté le seed : à la racine du projet, ',
      seedCmd: 'npm run db:seed',
      unavailable: 'Cette page n’est pas disponible dans cet environnement.',
      backHome: 'Accueil',
      backLogin: 'Connexion',
      columnRole: 'Rôle',
      columnEmail: 'E-mail',
      columnPassword: 'Mot de passe',
      columnRedirect: 'Après connexion',
      copyEmail: 'Copier l’e-mail',
      copyPassword: 'Copier le mot de passe',
      copied: 'Copié',
      openLogin: 'Connexion préremplie',
      roles: {
        admin: 'Administrateur',
        merchant: 'Commerçant',
        merchantDemo: 'Commerçant démo (parcours vitrine)',
        merchantE2e: 'Commerçant test E2E',
        driverDemo: 'Livreur démo (parcours interactif)',
        driver: 'Livreur test E2E',
        customer: 'Cliente (parcours catalogue)',
      },
      redirects: {
        admin: '/admin',
        merchant: '/dashboard',
        merchantDemo: '/demo/commerce',
        merchantE2e: '/dashboard',
        driver: '/driver',
        customer: '/client',
      },
      shopDemoTitle: 'Boutique de démonstration',
      shopDemoSlug: '/shop/boulangerie-muller-biel',
      loginHint: 'Depuis la page Connexion, vous pouvez aussi utiliser les raccourcis sous le formulaire.',
      loginFullPageLink: 'Ouvrir la page dédiée aux comptes de test',
      securityNote: 'Ne jamais activer l’affichage des comptes de test en production ni commiter de secrets réels.',
    },
  },
};

const de = {
  translation: {
    common: {
      loading: 'Lädt...',
      error: 'Ein Fehler ist aufgetreten',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      add: 'Hinzufügen',
      confirm: 'Bestätigen',
      back: 'Zurück',
      search: 'Suchen...',
      noResults: 'Keine Ergebnisse',
      currency: 'CHF',
    },
    nav: {
      dashboard: 'Dashboard',
      orders: 'Bestellungen',
      products: 'Katalog',
      stats: 'Statistiken',
      settings: 'Einstellungen',
      support: 'Support',
      logout: 'Abmelden',
      login: 'Anmelden',
      openMenu: 'Menü öffnen',
      closeMenu: 'Menü schliessen',
      mainNav: 'Hauptnavigation',
    },
    session: {
      timeoutTitle: 'Automatische Abmeldung',
      timeoutLabel: 'Inaktivitätszeit',
      timeoutHint: 'Nach einer Inaktivitätsphase werden Sie automatisch abgemeldet.',
      timeoutSaved: 'Zeitlimit gespeichert.',
      timeout15: '15 Minuten',
      timeout30: '30 Minuten',
      timeout60: '1 Stunde',
      timeout120: '2 Stunden',
      timeout240: '4 Stunden',
      timeoutNever: 'Nie (nicht empfohlen)',
      inactivityLogout: 'Sitzung wegen Inaktivität abgelaufen. Bitte melden Sie sich erneut an.',
    },
    auth: {
      login: 'Anmelden',
      register: 'Konto erstellen',
      email: 'E-Mail',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen?',
      noAccount: 'Noch kein Konto?',
      hasAccount: 'Bereits ein Konto?',
      demoAccountsTitle: 'Demo-Konten:',
      demoAccountsHint: 'Klicken Sie auf eine Zeile, um E-Mail und Passwort zu übernehmen.',
      demoRoleAdmin: 'Administrator',
      demoRoleMerchant: 'Händler',
      demoRoleDriver: 'Lieferant',
      demoRoleCustomer: 'Kundin',
    },
    dashboard: {
      welcome: 'Hallo, {{name}}!',
      todayOrders: 'Bestellungen heute',
      todayRevenue: 'Umsatz heute',
      avgBasket: 'Durchschnittlicher Warenkorb',
      avgRating: 'Durchschnittliche Bewertung',
      newOrders: 'Neue Bestellungen',
      inProgress: 'In Bearbeitung',
      shopStatus: 'Geschäftsstatus',
      open: 'Geöffnet',
      closed: 'Geschlossen',
      closeNow: 'Jetzt schließen',
      topProducts: 'Top-Produkte heute',
      storefrontPendingTitle: 'Vitrine wartet auf Freigabe',
      storefrontPending: 'Ihre Vitrine ist noch nicht online. Kunden sehen sie erst, wenn BienLivrer sie freigegeben hat.',
      plans: {
        link: 'Angebote ansehen',
        title: 'Ihre Angebote',
        intro: 'Starter ist gratis. Pro und Premium senken die Provision und erhöhen das Kataloglimit. Ein bezahltes Angebot startet am 1. des Folgemonats um 00:00 Uhr (Schweizer Zeit) und verlängert sich jeden Monat.',
        free: 'Gratis',
        perMonth: '{{price}} CHF / Monat',
        commission: 'Provision {{rate}} %',
        products: '{{max}} Artikel im Katalog',
        current: 'Aktuelles Angebot',
        choose: '{{name}} wählen',
        backToStarter: 'Zurück zu Starter',
        keep: '{{name}} behalten',
        scheduled: 'Rückkehr geplant',
        cancelScheduled: 'Rückkehr zu Starter am {{date}} um 00:00 Uhr (Schweizer Zeit). Bis dahin bleibt das bezahlte Angebot aktiv.',
        portal: 'Rechnungen und Zahlungsmittel',
        checkoutUnavailable: 'Das Online-Abo ist noch nicht geöffnet. Schreiben Sie BienLivrer, um das Angebot zu wechseln.',
        demoReadonly: 'Das Demokonto kann kein Abo abschliessen.',
        success: 'Karte gespeichert. Das wiederkehrende Abo wird am 1. des Folgemonats um 00:00 Uhr (Schweizer Zeit) aktiv.',
        cancelledCheckout: 'Abo abgebrochen. Es wurde nichts belastet.',
        catalogOver: 'Ihr Katalog hat {{count}} Artikel, über dem Limit dieses Angebots ({{max}}). Bestehende Artikel bleiben online; neue sind erst möglich, wenn der Überschuss archiviert ist.',
        trialDefer: 'Die erste Belastung erfolgt nach dem Ende Ihrer Testphase.',
        trialSoon: 'Ihre Testphase endet in weniger als 48 Stunden: die monatliche Belastung beginnt mit dem Abo.',
        error: 'Das Angebot kann im Moment nicht gewechselt werden.',
        confirmTitle: 'Wiederkehrendes Abo aktivieren',
        confirmBody: 'Sie aktivieren das Abo {{name}} für {{price}} CHF pro Monat. Es wird ab dem {{date}} um 00:00 Uhr (Schweizer Zeit) aktiv. Danach verlängert es sich jeden Monat, bis Sie zu Starter zurückkehren.',
        confirmYes: 'Abo aktivieren',
        confirmNo: 'Abbrechen',
        confirmCancelTitle: 'Wiederkehrendes Abo kündigen',
        confirmCancelBody: 'Sie kündigen das wiederkehrende Abo {{name}}. Es bleibt aktiv bis zum {{date}} um 00:00 Uhr (Schweizer Zeit). Ab diesem Zeitpunkt kehren Sie zu Starter zurück und die monatliche Belastung endet.',
        confirmCancelPending: 'Sie kündigen das wiederkehrende Abo {{name}}. Es wird nicht aktiviert. Die Kündigung gilt ab dem {{date}} um 00:00 Uhr (Schweizer Zeit).',
        confirmCancelYes: 'Abo kündigen',
        confirmCancelNo: 'Zurück',
        pendingStart: '{{name}} wird am {{date}} um 00:00 Uhr (Schweizer Zeit) aktiv. Die Belastung wiederholt sich jeden Monat.',
        planned: 'Bereits geplant',
        names: {
          starter: 'Starter',
          pro: 'Pro',
          premium: 'Premium',
        },
      },
    },
    orders: {
      title: 'Bestellungen',
      number: 'Bestellnr.',
      customer: 'Kunde',
      status: 'Status',
      total: 'Gesamt',
      type: 'Typ',
      date: 'Datum',
      accept: 'Annehmen',
      refuse: 'Ablehnen',
      markReady: 'Als bereit markieren',
      prepare: 'Vorbereiten',
      confirmPickup: 'Als abgeholt markieren',
      delivery: 'Lieferung',
      click_collect: 'Abholung',
      statuses: {
        pending: 'Ausstehend',
        accepted: 'Angenommen',
        preparing: 'Zubereitung',
        ready: 'Bereit',
        pickup: 'Kurier unterwegs',
        delivering: 'In Lieferung',
        delivered: 'Geliefert',
        completed: 'Abgeholt',
        cancelled: 'Storniert',
        refunded: 'Erstattet',
        pending_payment: 'Zahlung ausstehend',
      },
    },
    products: {
      title: 'Mein Katalog',
      add: 'Neues Produkt',
      name: 'Produktname',
      nameFr: 'Name (Français)',
      nameDe: 'Name (Deutsch)',
      nameEn: 'Name (English)',
      price: 'Preis CHF',
      stock: 'Lagerbestand',
      unlimited: 'Unbegrenzt',
      status: 'Status',
      category: 'Kategorie',
      active: 'Aktiv',
      draft: 'Entwurf',
      out_of_stock: 'Ausverkauft',
      allergens: 'Allergene',
      vatRate: 'MwSt-Satz',
    },
    onboarding: {
      title: 'Ihr Geschäft erstellen',
      step1: 'Grundinformationen',
      step2: 'Öffnungszeiten',
      step3: 'Bankdaten',
      step4: 'Erstes Produkt',
      next: 'Weiter',
      previous: 'Zurück',
      finish: 'Fertig',
    },
    client: {
      home: 'Startseite',
      myOrders: 'Meine Bestellungen',
      myProfile: 'Mein Profil',
      cart: 'Warenkorb',
      addToCart: 'In den Warenkorb',
      addedToCartToast: 'In den Warenkorb gelegt',
      viewCart: 'Warenkorb anzeigen',
      addedToCartLive: '{{name}} wurde in den Warenkorb gelegt.',
      removeFromCart: 'Aus dem Warenkorb entfernen',
      emptyCart: 'Ihr Warenkorb ist leer',
      orderNow: 'Bestellen',
      deliveryAddress: 'Lieferadresse',
      deliveryOrPickup: 'Lieferung oder Abholung?',
      notes: 'Besondere Anweisungen (optional)',
      coupon: 'Gutscheincode',
      applyCoupon: 'Anwenden',
      subtotal: 'Zwischensumme',
      deliveryFee: 'Liefergebühr',
      serviceFee: 'Servicegebühr',
      packagingDeposit: 'Verpackungspfand',
      discount: 'Rabatt',
      total: 'Gesamt',
      placeOrder: 'Bestellung aufgeben',
      orderPlaced: 'Bestellung aufgegeben!',
      trackOrder: 'Bestellung verfolgen',
      pickupCode: 'Abholcode',
      estimatedTime: 'Geschätzte Zeit',
      deliveryIn: 'Lieferung in ~{{min}} Min.',
      pickupIn: 'Bereit in ~{{min}} Min.',
      activeOrders: 'Aktiv',
      orderHistory: 'Verlauf',
      noActiveOrders: 'Keine aktiven Bestellungen',
      noHistory: 'Keine vergangenen Bestellungen',
      checkout: {
        errorGeneric: 'Bestellung konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
        errorNetwork: 'Keine Verbindung oder Server nicht erreichbar.',
        errorServer: 'Serverfehler. Bitte in Kürze erneut versuchen.',
        errorValidation: 'Ungültige Daten. Bitte Formular prüfen.',
        errorUnauthorized: 'Bitte anmelden, um zu bestellen.',
        submitting: 'Bestellung wird gesendet…',
        payCard: 'Online-Zahlung',
        payQrBill: 'QR-Rechnung',
        payCash: 'Bar bei Abholung',
        payCashHint:
          'Sie zahlen den Gesamtbetrag (Waren und Servicegebühr) bar an der Theke bei der Abholung.',
        payCashDeliveryOnly: 'Nur bei Abholung im Geschäft',
        payCashLocked:
          'Verfügbar ab Ihrer {{fromOrder}}. Online-Bestellung ({{current}}/{{required}} abgeschlossen).',
        payCashUnavailableDeposit:
          'Barzahlung ist nicht möglich: ein Verpackungspfand muss online eingezogen werden, damit wir es zurückerstatten können.',
        payCashCta: 'Bestellen und bei Abholung bar zahlen — CHF {{total}}',
        cartDialogTitle: 'Warenkorb',
        cartOpened: 'Warenkorb geöffnet. {{count}} Artikel. Gesamt {{total}} CHF.',
        cartClosed: 'Warenkorb geschlossen.',
        loginToOrderTitle: 'Anmeldung erforderlich',
        loginToOrderHint:
          'Melden Sie sich an, erstellen Sie ein Konto oder nutzen Sie das Gastformular unten. Warenkorb und Auswahl (Abholung / Lieferung, Zahlung) bleiben erhalten.',
        loginToOrderCta: 'Anmelden und bestellen',
        loginToOrderRegister: 'Konto erstellen',
        guestCheckoutToggle: 'Ohne Konto bestellen',
        guestCheckoutHint:
          'Es wird kein Konto angelegt. Wir nutzen diese Angaben nur zur Abwicklung Ihrer Bestellung und zur Kontaktaufnahme (Bestätigung, Lieferung).',
        guestFirstNameLabel: 'Vorname',
        guestLastNameLabel: 'Nachname',
        guestEmailLabel: 'E-Mail',
        guestPhoneOptionalLabel: 'Telefon (optional, +41…)',
        guestPhoneInvalid: 'Ungültige Telefonnummer: +41 und 9 Ziffern.',
        guestSubmitCta: 'Als Gast bestellen',
        guestSubmitting: 'Wird gesendet…',
        guestDividerOr: 'oder',
        continueToPayment: 'Weiter zur Zahlung',
        preparePaymentCta: 'Weiter zur Zahlung — CHF {{total}}',
        orderWithPaymentObligation: 'Zahlungspflichtig bestellen — CHF {{total}}',
        acceptLegalRequired: 'Bitte akzeptieren Sie die AGB und Nutzungsbedingungen.',
        paymentNotConfirmedYet:
          'Die Bestellung wird erst nach erfolgreicher Zahlung (Karte oder TWINT) bestätigt.',
        backToSummary: 'Zurück zum Warenkorb',
        stripePayTitle: 'Sichere Zahlung',
        stripePaySubtitle: 'Karte — Bestellung wartet auf Zahlungsbestätigung.',
        stripePayCta: 'CHF {{total}} zahlungspflichtig bezahlen',
        stripePayProcessing: 'Wird verarbeitet…',
        awaitingPaymentTitle: 'Bestellung erfasst',
        awaitingPaymentBody:
          'Sie erhalten eine E-Mail mit den nächsten Schritten (Karte oder TWINT). Verfolgen Sie die Bestellung unter „Meine Bestellungen“.',
        awaitingPaymentBodyGuest:
          'Sie erhalten eine E-Mail mit den nächsten Schritten (Karte oder TWINT). Bewahren Sie Ihre Bestellnummer unten auf.',
        stripePollTimeout:
          'Die Zahlung kann noch bestätigt werden. Öffnen Sie in Kürze „Meine Bestellungen“.',
        stripeOrderCancelled: 'Die Bestellung wurde storniert (Zahlung fehlgeschlagen).',
        wrongRoleHint:
          'Sie sind mit einem Händler- oder Lieferantenkonto angemeldet. Abmelden und mit einem Kundenkonto anmelden, um hier zu bestellen.',
        sectionAccount: 'Konto',
        sectionFulfillment: 'Abholung oder Lieferung',
        sectionYourOrder: 'Ihre Bestellung',
        sectionSummary: 'Übersicht',
        sectionPayment: 'Zahlungsart',
        signedInAs: 'Angemeldet als',
        tabHasAccount: 'Ich habe bereits ein Konto',
        tabGuest: 'Ohne Konto bestellen',
        deliveryAddressShort: 'Lieferadresse',
        totalTvaHint: 'MwSt. inbegriffen falls zutreffend',
        paymentChooseHint: 'Wählen Sie Ihre Zahlungsart.',
        paymentOnlineHint:
          'Sichere Online-Zahlung per Karte oder TWINT (über Stripe). Kein Bargeld, keine QR-Rechnung.',
        serviceFeeHint: 'Inkl. sichere Zahlungsabwicklung.',
      },
      ordersConnection: {
        offline: 'Offline — die Ansicht aktualisiert sich nach der Verbindung.',
        online: 'Verbindung wiederhergestellt.',
        syncing: 'Bestellungen werden aktualisiert…',
      },
      profile: {
        title: 'Mein Profil',
        firstNameLabel: 'Vorname',
        lastNameLabel: 'Nachname',
        emailLabel: 'E-Mail-Adresse',
        phoneLabel: 'Telefon',
        firstNameRequired: 'Vorname erforderlich',
        lastNameRequired: 'Nachname erforderlich',
        emailInvalid: 'Ungültige E-Mail',
        saveBtn: 'Speichern',
        saved: 'Profil gespeichert.',
        saveFailed: 'Speichern fehlgeschlagen. Bitte erneut versuchen.',
        gdprTitle: 'Persönliche Daten (DSGVO)',
        gdprExport: 'Daten exportieren',
        gdprDelete: 'Konto löschen',
        gdprDeleteConfirm: 'Ihr Konto wird anonymisiert. Diese Aktion ist unwiderruflich. Fortfahren?',
        gdprPasswordLabel: 'Passwort zur Bestätigung der Löschung',
        gdprPasswordRequired: 'Geben Sie Ihr Passwort ein, um das Konto zu löschen.',
        gdprRequestSent: 'Ihre Anfrage wurde erfolgreich gesendet.',
        changePasswordTitle: 'Passwort ändern',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort (min. 8 Zeichen)',
        confirmPassword: 'Neues Passwort bestätigen',
        passwordMismatch: 'Passwörter stimmen nicht überein',
        passwordChanged: 'Passwort erfolgreich geändert.',
      },
      shop: {
        deliveryBadge: 'Lieferung',
        clickCollectBadge: 'Click & Collect',
        pickup: 'Abholung',
        deliveryWithFee: 'Lieferung (+CHF {{fee}})',
        deliveryFromFee: 'Lieferung (CHF {{fee}})',
        deliveryOutOfZone: 'Ausserhalb des Liefergebiets',
        deliveryOffered: 'Inbegriffen',
        deliveryOfferedLabel: 'Kostenlose Lieferung',
        categoryAll: 'Alle',
        products: 'Produkte',
        noProducts: 'Keine Artikel verfügbar',
        notFound: 'Geschäft nicht gefunden',
        orderPlacedTitle: 'Bestellung aufgegeben!',
        orderPlacedBody: 'Ihre Zahlung ist bestätigt. Ihre Bestellung wird bearbeitet.',
        orderNumberLabel: 'Bestellnr.',
        pickupCodeLabel: 'Abholcode',
        newOrder: 'Neue Bestellung',
        viewCartShort: 'Warenkorb',
        cartArticleLabel: 'Artikel',
        closeCartOverlay: 'Warenkorb schließen',
        closeDialog: 'Schließen',
        deliveryAddressLabel: 'Lieferadresse *',
        deliveryAddressPlaceholder: 'Hauptgasse 5, 2500 Ort',
        orderNoteLabel: 'Bemerkung',
        orderNotePlaceholder: 'Sonderwünsche...',
        paymentMethod: 'Zahlungsmethode',
        onlineOrderPrice: 'Online-Bestellpreis',
        onlineOrderPriceHint: 'Die angezeigten Preise gelten für die Online-Bestellung.',
        packagingDeposit: 'Verpackungspfand +CHF {{amount}}',
        packagingDepositHint:
          'Pfand für Spezialverpackung (Kühlung, Fleisch…). BienLivrer behält es und erstattet es, wenn Sie die Verpackung im Laden zurückgeben.',
      },
      homePage: {
        searchPlaceholder: 'Geschäft suchen...',
        closed: 'Geschlossen',
        open: 'Offen',
        demo: 'Demo',
        delivery: 'Lieferung',
        pickup: 'Abholung',
        minOrder: 'Min. CHF {{amount}}',
        driverArea: 'Lieferantenbereich',
        driverProfile: 'Profil',
        merchantDashboard: 'Händler-Dashboard',
        merchantSettings: 'Einstellungen',
        admin: 'Administration',
        myOrders: 'Meine Bestellungen',
        myProfile: 'Mein Profil',
        logout: 'Abmelden',
        login: 'Anmelden',
        announcementCta: 'Kontakt / Details',
        brandSlogan: 'Kleiner Laden, grosse Lieferung.',
        heroTitle: 'Lokale Geschäfte, zu Ihnen geliefert',
        heroVision: 'Lokale Lieferung in der ganzen Schweiz',
        heroSubtitle: 'Bestellen Sie bei lokalen Händlern — Abendtour-Lieferung oder Abholung im Geschäft',
        register: 'Konto erstellen',
        loginCta: 'Anmelden',
        hello: 'Hallo, {{name}}!',
        taglineDriver: 'Katalog durchsuchen oder Lieferungen verwalten',
        taglineMerchant: 'Vitrine oder Händlerbereich öffnen',
        taglineAdmin: 'Vitrine oder Admin-Bereich',
        taglineCustomer: 'Was möchten Sie bestellen?',
        deliveriesLink: 'Lieferungen',
        dashboardLink: 'Dashboard',
        ordersLink: 'Bestellungen',
        featured: 'Im Fokus',
        pinned: 'Nicht verpassen',
        pinnedBadge: 'Tipp',
        newPartners: 'Neue Partner',
        locationBanner: 'Lokale Geschäfte in Ihrer Nähe',
        noResults: 'Kein Ergebnis',
        noShops: 'Keine Geschäfte verfügbar',
        resetSearch: 'Suche zurücksetzen',
        shopCountOne: '{{count}} Geschäft',
        shopCountMany: '{{count}} Geschäfte',
      },
    },
    driver: {
      title: 'Meine Lieferungen',
      space: 'Lieferantenbereich',
      available: 'Verfügbar',
      unavailable: 'Nicht verfügbar',
      activeDelivery: 'Aktive Lieferung',
      availableDeliveries: 'Verfügbare Fahrten',
      earnings: 'Wochenverdienst',
      accept: 'Fahrt annehmen',
      refuse: 'Ablehnen',
      pickup: 'Abholen',
      deliver: 'Liefern',
      delivered: 'Lieferung bestätigt',
      distance: 'Distanz',
      estimatedFee: 'Geschätzte Vergütung',
      noDeliveries: 'Keine Fahrten verfügbar',
      status: {
        searching: 'Fahrer suchen',
        awaiting_manual: 'Manuelle Zuweisung ausstehend',
        pending_acceptance: 'Zu bestätigen',
        assigned: 'Zugewiesen',
        heading_to_shop: 'Unterwegs zum Geschäft',
        at_shop: 'Im Geschäft',
        picked_up: 'Bestellung abgeholt',
        delivering: 'Bei Lieferung',
        delivered: 'Geliefert',
      },
    },
    admin: {
      title: 'Verwaltung',
      console: 'BienLivrer Verwaltungskonsole',
      myProfile: 'Mein Profil',
      overview: 'Übersicht',
      shops: 'Geschäfte',
      users: 'Benutzer',
      orders: 'Bestellungen',
      coupons: 'Gutscheine',
      reviews: 'Bewertungen',
      activeShops: 'Aktive Geschäfte',
      totalUsers: 'Benutzer',
      totalOrders: 'Gesamtbestellungen',
      revenue: 'Gesamtumsatz (CHF)',
      verify: 'Überprüfen',
      verified: 'Überprüft',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      suspended: 'Gesperrt',
      owner: 'Inhaber',
      createdAt: 'Erstellt am',
      refresh: 'Aktualisieren',
      sessionTimeoutTitle: 'Automatische Abmeldung',
      sessionTimeoutHint: 'Nach einer Inaktivitätsphase in der Admin-Konsole werden Sie automatisch abgemeldet.',
      sessionTimeoutSaved: 'Zeitlimit gespeichert.',
      sessionTimeout15: '15 Minuten',
      sessionTimeout30: '30 Minuten',
      sessionTimeout60: '1 Stunde',
      sessionTimeout120: '2 Stunden',
      sessionTimeout240: '4 Stunden',
      sessionTimeoutNever: 'Nie (nicht empfohlen)',
      sessionInactivityLogout: 'Sitzung wegen Inaktivität abgelaufen. Bitte melden Sie sich erneut an.',
    },
    gdpr: {
      cookieBanner: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern.',
      closeBanner: 'Cookie-Banner schließen',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
      learnMore: 'Mehr erfahren',
      privacyPolicy: 'Datenschutzrichtlinie',
      termsOfService: 'AGB',
    },
    errors: {
      notFound: 'Seite nicht gefunden',
      unauthorized: 'Nicht autorisiert',
      serverError: 'Serverfehler',
      networkError: 'Netzwerkfehler — prüfen Sie Ihre Verbindung',
      sessionExpired: 'Sitzung abgelaufen — bitte erneut anmelden',
      shopClosed: 'Dieses Geschäft ist derzeit geschlossen',
      outOfStock: 'Produkt ausverkauft',
      minOrder: 'Mindestbestellwert nicht erreicht (CHF {{amount}})',
    },
    merchantDemo: {
      bannerTitle: 'Demo-Umgebung',
      bannerBody: 'Beispielgeschäft « {{category}} ». Annehmen, vorbereiten, drucken und bis zur Lieferung verfolgen — nichts wird gespeichert.',
      changeCategory: 'Geschäftstyp wechseln',
      pickerTitle: 'Wählen Sie Ihren Geschäftstyp',
      pickerSubtitle: 'Der Händlerbereich passt sich Ihrer Auswahl an (Katalog, Bestellungen, Statistiken…).',
      readOnlyHint: 'Interaktiver Rundgang — für Ihr echtes Geschäft registrieren Sie sich als Partner.',
      persistBlocked: 'Demo-Umgebung — keine Änderung gespeichert.',
    },
    driverDemo: {
      bannerTitle: 'Demo-Umgebung Lieferant',
      bannerBody: 'Beispiel-Touren, Karte und Verdienst. Touren annehmen und Status aktualisieren — nichts wird gespeichert.',
      persistBlocked: 'Demo-Umgebung — keine Änderung gespeichert.',
    },
    devTestAccounts: {
      title: 'Testkonten',
      subtitle: 'Nur lokale Entwicklung. Seed ausführen (Projektstamm): ',
      seedCmd: 'npm run db:seed',
      unavailable: 'Diese Seite steht in dieser Umgebung nicht zur Verfügung.',
      backHome: 'Startseite',
      backLogin: 'Anmeldung',
      columnRole: 'Rolle',
      columnEmail: 'E-Mail',
      columnPassword: 'Passwort',
      columnRedirect: 'Nach der Anmeldung',
      copyEmail: 'E-Mail kopieren',
      copyPassword: 'Passwort kopieren',
      copied: 'Kopiert',
      openLogin: 'Anmeldung vorausfüllen',
      roles: {
        admin: 'Administrator',
        merchant: 'Händler',
        merchantDemo: 'Demo-Händler (Schaufenster)',
        merchantE2e: 'Test-Händler E2E',
        driverDemo: 'Demo-Lieferant (interaktiv)',
        driver: 'Test-Lieferant E2E',
        customer: 'Kundin (Katalog)',
      },
      redirects: {
        admin: '/admin',
        merchant: '/dashboard',
        merchantDemo: '/demo/commerce',
        merchantE2e: '/dashboard',
        driver: '/driver',
        customer: '/client',
      },
      shopDemoTitle: 'Demo-Geschäft',
      shopDemoSlug: '/shop/boulangerie-muller-biel',
      loginHint: 'Auf der Anmeldeseite stehen unter dem Formular ebenfalls Kurzwahl-Konten zur Verfügung.',
      loginFullPageLink: 'Seite mit allen Testkonten öffnen',
      securityNote: 'Testkonten niemals in Produktion anzeigen; keine echten Geheimnisse committen.',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr, de, en, it },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'de', 'en', 'it'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
